import type { ColumnDef } from "@tanstack/react-table";
import type { Fakultas } from "../api/get-fakultas";

export const columnsFakultas: ColumnDef<Fakultas>[] = [
  {
    accessorKey: 'kode_fakultas',
    header: 'Kode Fakultas',
  },
  {
    accessorKey: 'nama_fakultas',
    header: 'Nama Fakultas',
  },
];
